import { render, staticRenderFns } from "./DefaultTitle.vue?vue&type=template&id=3f5aa966"
import script from "./DefaultTitle.vue?vue&type=script&lang=js"
export * from "./DefaultTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports